module.exports = __webpack_public_path__ + "img/tarde_c4@2x.1390fd64.png";